<template>
  <div>
    <n-dialog-header
      :isField="isField"
      :isShowOtherTypes="isShowOtherTypes"
      :from="'question'"
      :courseId="courseId"
      :subjectId="subjectId"
      :dialogVisible="dialogVisible"
      :chooseNum="chooseNum"
      @searchFunc="searchFunc"
      @changeCategory="changeCategory"
    ></n-dialog-header>
    <div class="main">
      <div class="left_tree">
        <!-- 书证融通 + 产品模式 -->
        <catalog-tree
          ref="leftTree"
          :subjectId="subjectId"
          :height="'350px'"
          @treeClick="treeClickSearch"
          v-if="courseModel == 2"
        ></catalog-tree>
        <!-- 书证融通 + 标准模式 -->
        <standard-product :height="'350px'" @showListStandard="showListStandard" ref="leftTree" v-else></standard-product>
      </div>
      <div class="right_table">
        <n-table
          ref="question_testArea"
          v-loading="loading"
          :tableData="tableData"
          :tableHeader="QuestionDialogTableHeader"
          :ISChangeCheckout="true"
          :TableHeight="'320px'"
          :canExpand="true"
          @operation="operation"
        ></n-table>

        <Pagination
          :currentpage="pageTotal.currentPage"
          :limit="pageTotal.pageSize"
          :total="pageTotal.total"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :small="true"
          :key="addQuestionKey"
        ></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../../../../api/newCourseApi.js";
import nDialogHeader from "../../../components/n_dialog_header.vue";
import { QuestionDialogTableHeader } from "../../../global/table_header_data";
import Pagination from "../../../../../components/paginator/paginator.vue";
import catalogTree from "../../../components/catalog-tree.vue";
import standardProduct from "../../../components/standardProduct.vue";
export default {
  name: "addQuestion",
  components: {
    nDialogHeader,
    Pagination,
    catalogTree,
    standardProduct
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    courseId: {
      type: [Number, String],
      default: "",
    },
    subjectId: {
      type: [Number, String],
      default: "",
    },
    isField: { //是否只显示实操题
      type: Boolean,
      default: false,
    },
    isShowOtherTypes: { //除单，多，判，实操
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      QuestionDialogTableHeader: QuestionDialogTableHeader,
      searchParams: {
        categoryId: "", // 资源分类id
        questionType: "", // 题型id
        difficulty: "", // 难度,1:简单，2:中等，3:困难
        name: "", // 资源名称
      },
      tableData: [],
      multipleSelection: [],
      chooseNum: 0,
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      materialData: [],
      addQuestionKey: 0,
      selectCourseId: '', // 课程切换
      selectSubjectId: '', // 科目切换
      courseModel: this.$route.query.courseModel || '', // 产品模式 1标准 2产品
    };
  },
  created() {},
  mounted() {
    // this.queryQuestionList();
    this.$refs.leftTree.treeList();
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.$refs.leftTree.treeList();
        // this.queryQuestionList();
      } else {
        this.emptyData();
      }
    },
  },
  methods: {
    // 标准模式 根据课程查询试题
    showListStandard(courseId) {
      this.selectCourseId = courseId;
      this.addQuestionKey++;
      this.pageTotal.pageSize=10;
      this.pageTotal.currentPage=1;
      this.queryQuestionListByCourse();
    },
    // 查询list 产品模式
    queryQuestionList() {
      this.loading = true;
      // let params = {
      //   beginTime: null, //开始时间
      //   endTime: null, //结束时间
      //   difficulty: this.searchParams.difficulty, //难度
      //   labelId: 6, //书证融通
      //   materialIds: this.materialData, //目录id集合
      //   pageNo: this.pageTotal.currentPage, //当前页
      //   pageSize: this.pageTotal.pageSize, //每页个数
      //   questionContent: this.searchParams.name, //试题内容
      //   questionTypeId: this.searchParams.questionTypeId, //题型id
      //   subjectId: this.subjectId, //科目id
      //   filterQuestionType: 6, // 暂时过滤 不定项选择题
      // };
      // api
      //   .SelectNoEncryptionQuestion(params)

      let params = {
          labelId: "",
          pageNo: this.pageTotal.currentPage,
          pageSize: this.pageTotal.pageSize,
          queryName: this.searchParams.name,
          questionTypeId: this.searchParams.questionTypeId ? parseInt(this.searchParams.questionTypeId) : '',
          subjectId: this.selectSubjectId || this.subjectId,
          beginTime: null,
          endTime: null,
          difficulty: this.searchParams.difficulty,
          companyId: null,
          personLabels: [],
          materialIds: this.materialData, // 知识点
          skillIds: [], // 技能点
          filterQuestionType: 6, // 暂时过滤 不定项选择题   
        };
      api
        .queryTestResourceData(params)
        .then((res) => {
          if (res.code == "0") {
            let datas = res.data.list;
            [].forEach.call(datas, item => {
              if (item.taskName == null || item.taskName == "") {
                let str = item.questionContent
                if(str){
                  let content = this.$delHtmlTag.delHtmlTag(str)
                  if(content.substring(0,100).length>=100){
                    item.taskName = `${content.substring(0,100)}...`;
                  }else{
                    item.taskName = `${content.substring(0,100)}`;
                  }
                }
              }
            })
            this.tableData = datas;
            this.pageTotal.total = res.data.totalCount;

            // 重置选中
            this.$refs.question_testArea.ClearData();
            this.multipleSelection = [];
            this.chooseNum = 0;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    // 查询list 标准模式
    queryQuestionListByCourse() {
      this.loading = true;
      let params = {
          "courseId": this.selectCourseId,            //课程id
          "name": this.searchParams.name,  //资源名称
          "difficulty": this.searchParams.difficulty,	     //难度,1:简单，2:中等，3:困难
          "questionType": this.courseModel != 1 ? this.searchParams.questionType : undefined,        //内部题型 (1:单选题，2：多选题，3：判断题，4:填空题，5：问答题，6：组合题，7：连线题，8：配伍选择题，9：操作题，10：附件题)
          "pageNum": this.pageTotal.currentPage,
          "pageSize": this.pageTotal.pageSize,
          "resourceType": 3,        //资源类型(1:ppt,2:文件,3:试题,4:视频,5:试卷,6:共享资源，7素材（查询：视频、ppt、文件）)
          "materialIds": [],      //知识点类型
          "skillIds": [],      //技能点类型
          "filterQuestionType": 6, // 暂时过滤 不定项选择题
          courseModel: this.courseModel, // 1 标准(只查单，多，判，操)
          internaltypeid: this.courseModel == 1 ? this.searchParams.internaltypeid : undefined, // 系统题型
        }
      api
        .FindPageResource(params)
        .then((res) => {
          if (res.code == "0") {
            let datas = res.data.list;
            [].forEach.call(datas, item => {
              if (item.taskName == null || item.taskName == "") {
                let str = item.questionContent
                if(str){
                  let content = this.$delHtmlTag.delHtmlTag(str)
                  if(content.substring(0,100).length>=100){
                    item.taskName = `${content.substring(0,100)}...`;
                  }else{
                    item.taskName = `${content.substring(0,100)}`;
                  }
                }
              }
            })
            this.tableData = datas;
            this.pageTotal.total = res.data.total;

            // 重置选中
            this.$refs.question_testArea.ClearData();
            this.multipleSelection = [];
            this.chooseNum = 0;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      // console.log(this.$refs.question_testArea);
      // this.$refs.question_testArea.scrollTop = 0;
      if (this.courseModel == 2) {
        this.queryQuestionList();
      } else {
        this.queryQuestionListByCourse();
      }
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      // this.$refs.question_testArea.scrollTop = 0;
      if (this.courseModel == 2) {
        this.queryQuestionList();
      } else {
        this.queryQuestionListByCourse();
      }
    },
    operation(type, RowData) {
      if (type == "selectChange") {
        // 选中
        this.multipleSelection = RowData;
        this.chooseNum = this.multipleSelection.length;
      } else if (type == "preview") {
        console.log("preview");
      } else if (type == "delete") {
        console.log("delete");
      }
    },
    // tree 点击
    treeClickSearch(arr, subId) {
      this.materialData = arr;
      this.selectSubjectId = subId;
      this.addQuestionKey++;
      this.pageTotal.pageSize=10;
      this.pageTotal.currentPage=1;
      this.queryQuestionList();
    },
    searchFunc(param) {
      this.pageTotal.currentPage = 1;
      this.searchParams.questionTypeId = param.questiontypeId;
      this.searchParams.difficulty = param.difficulty;
      this.searchParams.name = param.name;
      this.searchParams.internaltypeid = param.internaltypeid;
      if (this.courseModel == 2) {
        this.queryQuestionList();
      } else {
        this.queryQuestionListByCourse();
      }
    },
    emptyData() {
      this.searchParams = {
        categoryId: "", // 资源分类id
        questionTypeId: "", // 题型id
        difficulty: "", // 难度,1:简单，2:中等，3:困难
        name: "", // 资源名称
      };
      this.pageTotal = {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };
      this.tableData = [];
      this.multipleSelection = [];
      this.materialData = [];
      this.chooseNum = 0;

    },
    changeCategory(id) {
      this.searchParams.categoryId = id;
    }
  },
};
</script>

<style scoped lang="scss">
.main {
  display: flex;
  justify-content: space-between;
  .left_tree {
    width: 215px;
    padding: 16px 0px;
  }
  .right_table {
    width: 580px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/question/addQuestion.vue